'use client';

import {
  LDProvider,
  reactSdkContextFactory,
} from 'launchdarkly-react-client-sdk';
import { type PropsWithChildren } from 'react';

import { useUser } from './useUser';

interface LaunchDarklyProviderProps extends PropsWithChildren {
  clientId?: string;
}

export const flagsContext = reactSdkContextFactory();

export const LaunchDarklyProvider = (props: LaunchDarklyProviderProps) => {
  const { currentProjectId } = useUser();
  if (!currentProjectId) {
    return props.children;
  }

  if (!props.clientId) {
    return (
      <flagsContext.Provider
        value={{
          flags: {
            // Amir
            tagsFiltersV2: true,

            // Erez
            enableHourlyBackup: false, // opened only for Fanatics
            highFrequencyBackupPolicy: true,
            ransomwareByCondition: true,
            enabledBackupScopes: false,
            dbQueryStorageAccountSelection: true,
            jobsDataAccess: true,

            // caldesh
            DynamoDBSupport: true,

            // Moshe
            enableS3ExclusionRules: true,

            // waiting for prod/ux
            orgWithoutStackSet: false,

            // Encryption
            includeAwsManagedKeys: true,

            // Ran
            terraformAzureOnboarding: true,

            // Dor Kleiman
            customerOwnedAWSAccounts: true,
            // Ilya
            VaultCmk: true,
          },
          flagKeyMap: {},
          ldClient: undefined,
        }}
      >
        {props.children}
      </flagsContext.Provider>
    );
  }

  return (
    <LDProvider
      reactOptions={{
        reactContext: flagsContext,
        useCamelCaseFlagKeys: false,
      }}
      clientSideID={props.clientId}
      context={{
        key: currentProjectId || '',
      }}
      options={
        {
          /* ... */
        }
      }
    >
      {props.children}
    </LDProvider>
  );
};
